function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }
  summary.addEventListener("click", (event) => {
    const hasPlusIcon = summary.querySelector(".pdp-accordion__summary,.closed");
    const hasMinusIcon = summary.querySelector(
      ".pdp-accordion__summary,.opened"
    );
    const clickedElement = event.target.closest(".pdp-accordion__summary");
    const allSummarys = document.querySelectorAll(".pdp-accordion__summary");

    if (hasPlusIcon) {
      hasPlusIcon.classList.toggle("opened");
      hasPlusIcon.closest('summary').setAttribute("aria-expanded", "true");
      hasPlusIcon.closest('summary').nextElementSibling.setAttribute("aria-hidden", "false");
    } else if (hasMinusIcon) {
      hasMinusIcon.classList.toggle("opened");
      hasMinusIcon.closest('summary').setAttribute("aria-expanded", "false");
      hasMinusIcon.closest('summary').nextElementSibling.setAttribute("aria-hidden", "true");
    }
    allSummarys.forEach((el) => {
      if (el !== clickedElement && el.parentElement.hasAttribute("open")) {
        el.setAttribute("aria-expanded", "false");
        el.closest("details").removeAttribute("open");
        el.querySelector(".plus-minus-icon,.opened").classList.toggle("opened");
        el.nextElementSibling.setAttribute("aria-hidden", "true");
      }
    });
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", keyboardActions);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function keyboardActions(event) {
  const firstAccordionHeading = event.target.closest('ul').firstElementChild.querySelector('summary');
  const lastAccordionHeading = event.target.closest('ul').lastElementChild.querySelector('summary');

  if (event.code.toUpperCase() == "ESCAPE") {
    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector("summary");
    openDetailsElement.removeAttribute("open");
    summaryElement.setAttribute("aria-expanded", false);
    summaryElement.focus();
  } else if (event.target === firstAccordionHeading && event.code.toUpperCase() == "ARROWUP") {
    lastAccordionHeading.focus();
  } else if (event.target === lastAccordionHeading && event.code.toUpperCase() == "ARROWDOWN") {
    firstAccordionHeading.focus();
  } else if (event.code.toUpperCase() == "ARROWUP") {
    event.target.closest("li").previousElementSibling.querySelector('summary').focus();
  } else if (event.code.toUpperCase() == "ARROWDOWN") {
    event.target.closest("li").nextElementSibling.querySelector('summary').focus();
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-form__select)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    const currentCurrency = Shopify.currency.active;
    const activeButton = document.querySelectorAll('span[class*="'+ currentCurrency +'"]');
    for (let i = 0; i < activeButton.length; i++) {
      activeButton[i].classList.add("current_currency");
    }

    this.elements = {
      input: this.querySelector(
        'input[name="locale_code"], input[name="country_code"]'
      )
    };
    this.isCollection =
      location.href.includes("collections") &&
      !location.href.includes("products")
        ? true
        : false;
    this.isCollectionPage();
    this.querySelectorAll(".localization-form__currency").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
      );
  }

  isCollectionPage() {
    // if collection page and there is a localStorage and not tag param
    if (
      this.isCollection &&
      localStorage.getItem("currencySwitch") &&
      !window.location.search.includes("tag") &&
      !location.href.includes("accessoires") &&
      !location.href.includes("accessories") &&
      !location.href.includes("limited-edition")
    ) {
      var search = new URLSearchParams(window.location.search);
      const tag = localStorage.getItem("currencySwitch");
      search.append("tag", tag);
      window.history.replaceState({}, "", `${location.pathname}?${search}`);
      document
        .querySelector(".product-tabs_wrapper[data-name=" + tag + "]")
        .classList.add("active");
      localStorage.removeItem("currencySwitch");
    }
    if (
      this.isCollection &&
      window.location.search.includes("tag") &&
      !location.href.includes("accessoires") &&
      !location.href.includes("accessories")
    ) {
      localStorage.setItem(
        "currencySwitch",
        window.location.search.replace("?tag=", "")
      );
    }
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (poster) {
      poster.addEventListener("click", this.loadContent.bind(this));
    } else {
      this.loadContent();
    }
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      window.pauseAllMedia();

      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      ).focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li.slider__slide");
    this.sliderCounter = this.querySelector(".slider-counter");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.initEventListener();
  }

  initEventListener() {
    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / sliderItemsToShow[0].clientWidth
    );
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;

    const hasBlocks = this.classList.contains("slider-counter-blocks");
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (hasBlocks) {
      const listElements = this.querySelectorAll(".slider-counter-element");
      for (let i = 0; i < listElements.length; i++) {
        listElements[i].classList.remove("slider-counter--current");
      }
      listElements[this.currentPage - 1].classList.add(
        "slider-counter--current"
      );
    }

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", "disabled");
      if (hasBlocks) this.prevButton.classList.add("visibility-hidden");
    } else {
      this.prevButton.removeAttribute("disabled");
      if (hasBlocks) this.prevButton.classList.remove("visibility-hidden");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", "disabled");
      if (hasBlocks) this.nextButton.classList.add("visibility-hidden");
    } else {
      this.nextButton.removeAttribute("disabled");
      if (hasBlocks) this.nextButton.classList.remove("visibility-hidden");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();

    const gapSize =
      getComputedStyle(this.slider)["column-gap"].split("px")[0] * 1; // since the computed style will give us a string, we need to cut of px at the end

    if (!gapSize) {
      gapSize = 0;
    }

    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + (this.sliderLastItem.clientWidth + gapSize)
        : this.slider.scrollLeft - (this.sliderLastItem.clientWidth + gapSize);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

/**
 * Variant-picker for PDP
 * Is inherited by VariantRadio and VariantRadiosAccessories
 * Used on PDP when neither button nor swatches is selected for the variant-picker (displays as drop-down)
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    // set section root element
    this.section = document.querySelector(
      `#shopify-section-${this.dataset.section}`
    );

    this.initNote();

    // set the states based on clases existing in the section
    this.isComing = this.section.querySelector(".is-coming-soon");
    this.isNotify = this.section.querySelector(".product.is-notify");
    this.isGlobalStrike = this.section.querySelector(".is-global-strike");
    this.isSoldout = this.section.querySelector(".fully-soldout");

    // check, if this is the featured element, because then, we have to take a different root element
    // TODO: [december refactoring] this could be moved to the top, so we only would need to set the states once
    if (this.section.classList.contains("featured-product-section")) {
      // do a little magic to get the product id which we will need to get the section
      let productId = "";

      this.classList.forEach((c) => {
        if (c.startsWith("js-variantRadios-")) {
          productId = c.split("js-variantRadios-")[1];
        }
      });

      // change the root element accordingly
      this.section = this.section.querySelector(`.js-product-${productId}`);

       // set the states based on clases existing in the section
      this.isComing = this.section.classList.contains("is-coming-soon");
      this.isNotify = this.section.classList.contains("is-notify");
      this.isGlobalStrike = this.section.classList.contains("is-global-strike");
      this.isSoldout = this.section.classList.contains("fully-soldout");
      this.isSoldoutNotify = this.section.querySelector("is-notify.fully-soldout");
    }

    // the note contains the short text under the CTA, if it is not preorder or just the shipping note
    // TODO: [december refactoring] why do we have 3 types of notes? Couldn't it just be one with different content depending on the case?
    this.note = this.section.querySelector(".product-form__note");

    // get the variant-id from the url, if there is none it will be undefined
    this.id = window.location.search.split("?variant=")[1];

    // get the unit price - this is the case for some accessories
    this.unitPrice = this.section.querySelector(".unit-price .price-item").textContent.replace(/\s/g, "");

    // get the CTA and the CTA text
    this.addButton = this.section.querySelector('[name="add"]');
    this.addButtonText = this.section.querySelector('[name="add"] > span');

    // get the Notify CTA
    this.notifyButton = this.section.querySelector(".button-notify");

    // get the global strike day CTA
    this.gsdButton = this.section.querySelector(".button-gsd");

    // get the shipping note. it will contain shipping times and will be displayed under the CTA for products that can be purchased and shipped
    this.noteShipping = this.section.querySelector(".product-form__shipping");

    // get the pre-order note which will display under the CTA for pre-order products
    this.notePreorder = this.section.querySelector(".product-form__preorder-note");

    // for accesories with several options e.g. laces
    this.isUnavailableSwatchCombination = false;

    // to check, if we are on an accessory PDP
    this.isAccessoires = window.template.name === "accessoires" ? true : false;

    // check if the product has any variants that are available for preorder
    this.hasPreOrderSizes = this.checkForPreorderSizes();

    // check if we have a sale and use a different price
    if(this.section.querySelector(".price.price--on-sale")) {
      this.isSale = true;
      this.price = this.section.querySelector(".price-item.price-item--sale").textContent;
    } else {
      this.isSale = false;
      this.price = this.section.querySelector(".price-item.price-item--regular").textContent;
    }

    // to remove extra parameters
    if (this.id.includes("&")) {
      this.id = this.id.slice(0, this.id.indexOf("&"));
    }

    // set soldout notify state for the case that we have an ID because a variant is selected
    if (this.id) {
      this.isSoldoutNotify = document.querySelector(
        `.product_${this.id}.is-soldout.has-notify`
      );
    }

    // if no variant id is in url, create the state for "no item selected"
    // TODO: [december refactoring] we did that step above getting the ID, why are we not using that here?
    if (!window.location.search.split("?variant=")[1]) {
      this.isAccessoires ? this.resetAccessoire() : this.resetState();
    } else { // we have a selected variant

      // update color-variant url for size on tanuki pdp
      this.updateSwatchUrl();

      // set the CTA state and show/hide the notes we need

      // product should not have notify, not be fully sold out or have soldout+notify
      if (!this.isNotify && !this.isSoldoutNotify && !this.isSoldout && !this.isComing) {
        this.addButton.removeAttribute("disabled");
        this.addButton.removeAttribute("aria-disabled");

        if(!this.hasPreOrderSizes) {
          this.addButtonText.textContent =
            window.variantStrings.addToCart + " - " + this.price;
        } else if ( this.variantIsPreOrder() ){
          this.addButtonText.textContent =
            window.variantStrings.preorder + ` - ${this.price}`;
          if (this.note) this.note.style.display = "none";
          if (this.noteShipping) this.noteShipping.style.display = "none";
          if (this.notePreorder) this.notePreorder.classList.remove('hidden');
        }
      } else {

        if (!this.isGlobalStrike && !this.isComing) {
          this.addButtonText.textContent =
            `${window.variantStrings.addToCart} - ${this.price}`;

          this.setNotifyButtonState();

          if (this.isComing && !this.isSoldout) { // TODO: refactor, hier kommt er nie an
            this.addButtonText.textContent = window.variantStrings.soon;
          } else if (this.isSoldout) {
            this.addButtonText.textContent = window.variantStrings.soldOut;
            if (this.note) this.note.style.display = "flex";
            if (this.noteShipping) this.noteShipping.style.display = "none";
          }
        } else if (this.isComing) {
          this.isComingSoon();
        } else {
          this.notifyButton.classList.add("hidden");

          // hide sizes on gsd
          this.productInformationWrapper.style.display = "none";
        }
      }
      if ( this.variantIsPreOrder() ){
        this.addButtonText.textContent =
          window.variantStrings.preorder + ` - ${this.price}`;
        this.addButton.classList.remove('hidden');
        if (this.note) this.note.style.display = "none";
        if (this.noteShipping) this.noteShipping.style.display = "none";
        if (this.notePreorder) this.notePreorder.classList.remove('hidden');
      }
    }

    // if it's coming soon or global strike, deactivate the size-selection
    if (!this.isComing && !this.isGlobalStrike) {
      this.addEventListener("change", this.onVariantChange);
    } else {
      if (this.note) this.note.style.display = "flex";
      if (this.noteShipping) this.noteShipping.style.display = "none";
    }
  }

  /**
   * checks if there are any sizes with pre-order stock for this product
   * @returns true, if there is minimum one size with preorder
   */
  checkForPreorderSizes() {
    // get all size-inputs that have the pre-order class
    let preOrderSizes = this.section.querySelectorAll(`.product-form__input input[type='radio'].is-preorder`);

    if( preOrderSizes && preOrderSizes.length > 0 ) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * checks if the currently selected variant has pre-order stock
   * @returns true, if a variant is selected and it has preorder stock
   */
  variantIsPreOrder() {
    if( !this.id) return false; // no variant-id, no service :P

    // check, if we have a size-selector for this variant that also has the preorder class
    if(this.section.querySelector(`input.product_${this.id}.is-preorder`)) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Eventlistener called when a size is selected
   */
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.removeErrorMessage();
    this.updatePrice();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateDataSet();
      if (window.location.search.split('?variant=')[1]) {
        this.updateSwatchUrl(); // update color-variant url for size on tanuki pdp
        this.updateMedia();
      }
      this.updateVariantInput();
      this.updateShareUrl();
      this.renderProductInfo();
    }

    // hide preoorder note if a variant has been selected that has no pre-order stock
    if(this.currentVariant && !this.variantIsPreOrder()) this.notePreorder.classList.add('hidden');
  }

  /**
   * Update the dataset of the product-form
   */
  updateDataSet() {
    if (!this.currentVariant) return;
    this.section.querySelector('product-form').dataset.variantId = this.currentVariant.id;
    this.section.querySelector('product-form').dataset.selectedVariantName = this.currentVariant.title;
    this.section.querySelector('product-form').dataset.selectedVariantPrice = this.currentVariant.price;
  }

  /**
   * Updates the links for the color swatches adding the right variant-id for the selected size
   */
  updateSwatchUrl() {
    //only for tanuki pdp
    if(document.querySelector('.product-color-swatch-wrapper')) {
      // get the selected size (e.g. EU 37)
      // @TODO: remove whitespaces from size as well here as in the liquid
      let selectedSize = document.querySelector('input[type = radio]:checked').value;

      // get the wrapper containing all color swatches
      const swatchWrapper = document.querySelector('.product-color-swatch-wrapper');

      if(swatchWrapper) { // if we have a wrapper we are on the tanuki pdp yay \o/
        let swatches = swatchWrapper.querySelectorAll('div.product-color-swatch-element'); // get the elements containing the swatches for each color

        swatches.forEach( (swatch) => { // and loop through all colors
          let link = swatch.querySelector('a'); // get the a element linking to the color
          let swatchColorSizeId = swatch.querySelector(`li[data-shoesize="${selectedSize}"]`).innerHTML; // get the right id for the color & the selected size

          if (link.href.split('?variant=')[1]) { // if it already has a variant-id in the href
            link.href = `${link.href.split('?variant=')[0]}?variant=${swatchColorSizeId}`;
          } else {
            link.href += `?variant=${swatchColorSizeId}`;
          }
        });
      }
    }
  }

  // if choosen product is soldout and has notify, change buttons and notes
  setNotifyButtonState() {
    if (this.note) this.note.style.display = "flex";
    if (this.noteShipping) this.noteShipping.style.display = "none";
    if (this.isSoldoutNotify && !this.isGlobalStrike) {
      this.addButton.classList.add("hidden");
      this.notifyButton.classList.remove("hidden");
      if (this.note) this.note.style.display = "flex";
      if (this.noteShipping) this.noteShipping.style.display = "none";
    } else {
      this.addButton.classList.remove("hidden");
      this.notifyButton.classList.add("hidden");
      this.gsdButton.classList.add("hidden");
      if (this.note) this.note.style.display = "none";
      if (this.noteShipping) this.noteShipping.style.display = "flex";
    }
  }

  /**
   * Builds the state displayed when no variant is selected
   */
  resetState() {
    // remove the checked checkbox as a reset if no variant is chosen
    const checkedInput = this.section.querySelector("input:checked");

    if (checkedInput) {
      checkedInput.removeAttribute("checked");
    }

    // product is soldout but it's not global strike day
    if (this.isSoldout && !this.isGlobalStrike) {
      if( this.hasPreOrderSizes ) {
        this.toggleAddButton(true, window.variantStrings.choose_size, false);
        if (this.note) this.note.style.display = "none";
        if (this.notePreorder) this.notePreorder.classList.remove('hidden');
      } else {
        if (this.note) this.note.style.display = "flex";
      }
      if (this.noteShipping) this.noteShipping.style.display = "none";
      if (this.isNotify) {
        if( !this.hasPreOrderSizes ){
          this.addButton.classList.add("hidden");
          if (this.note) this.note.style.display = "flex";
          this.notifyButton.classList.remove("hidden");
        }
        if (this.noteShipping) this.noteShipping.style.display = "none";
      }
    } else {
      // if it is global strike, show text for it
      if (this.isGlobalStrike) {
        this.isGlobalStrikeDay(this.productInformationWrapper);
        // otherwise show default 'choose size' button
      } else if (this.isComing) {
        this.hasComingSoonTag();
      } else {
        this.toggleAddButton(true, window.variantStrings.choose_size, false);
        if (this.note) this.note.style.display = "none";
        if (this.noteShipping) this.noteShipping.style.display = "flex";
      }
    }
  }

  /**
   * Builds the state displayed when no variant is selected on accessory pages
   */
  resetAccessoire() {
    // get options to check what state they have
    const select = this.section.querySelector('[id^="Option-"]');
    const inputDropdown = this.section.querySelector(".product-form__input");

    // global strike or coming soon
    if (this.isGlobalStrike) {
      this.isGlobalStrikeDay(inputDropdown);
      // otherwise show default 'choose size' button
    } else if (this.isComing) {
      this.hasComingSoonTag();
    } else if (select && select.length > 0) {
      const isSelected = select.options[select.selectedIndex];
      const classes = isSelected.classList;
      // sold out and selected - show addButton but toggle disabled
      if (classes.contains("is-soldout") && isSelected) {
        // if notify
        if (classes.contains("has-notify")) {
          this.addButton.classList.add("hidden");
          this.notifyButton.classList.remove("hidden");
        } else {
          this.addButton.classList.remove("hidden");
          this.notifyButton.classList.add("hidden");
          this.toggleAddButton(true, window.variantStrings.soldOut, true);
        }
        if (this.noteShipping) this.noteShipping.style.display = "none";
        if (this.productFormNote) this.note.style.display = "flex";
      } else {
        // not sold out behaviour
        // as we don't have the current variant yet, we take price from element and remove breaks and spaces

        this.addButton.classList.remove("hidden");
        this.notifyButton.classList.add("hidden");
        if (this.noteShipping) this.noteShipping.style.display = "flex";
        if (this.note) this.note.style.display = "none";
        this.addButtonText.textContent =
          window.variantStrings.addToCart + ` - ${this.price}`;
      }
    } else {
      // single variant, no options
      const product = this.section.querySelector("#product-single");
      const classes = product.classList;
      if (classes.contains("is-soldout")) {
        if (classes.contains("has-notify")) {
          this.addButton.classList.add("hidden");
          this.notifyButton.classList.remove("hidden");
        } else {
          this.addButton.classList.remove("hidden");
          this.notifyButton.classList.add("hidden");
          this.toggleAddButton(true, window.variantStrings.soldOut, true);
        }
        if (this.note) this.note.style.display = "flex";
        if (this.noteShipping) this.noteShipping.style.display = "none";
      } else {
        this.addButton.classList.remove("hidden");
        this.notifyButton.classList.add("hidden");
        if (this.noteShipping) this.noteShipping.style.display = "flex";
        if (this.note) this.note.style.display = "none";
      }
    }
  }

  /**
   * Builds the global strike day state
   * @param {*} input
   */
  isGlobalStrikeDay(input) {
    this.addButton.classList.add("hidden");
    this.notifyButton.classList.add("hidden");
    if (this.note) this.note.style.display = "flex";
    if (this.noteShipping) this.noteShipping.style.display = "none";
    if (input) input.style.display = "none";
  }

  /**
   * Builds the coming soon state
   */
  hasComingSoonTag() {
    this.toggleAddButton(true, window.variantStrings.soon, false);
    if (this.noteShipping) this.noteShipping.style.display = "none";
  }

  // TODO: [december refactoring] what is the difference to the function above? Can we unify them?
  isComingSoon() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, window.variantStrings.soon, true);
  }

  /**
   * get the initial text for the note to be displayed under the CTA
   * @returns
   */
  initNote() {
    // if current variant is soldout with notify
    // either soldout and notify OR soon tag
    if (this.note && this.id) {
      if (this.noteShipping) this.noteShipping.style.display = "none";
      return this.isSoldoutNotify || this.isComing
        ? (this.note.style.display = "flex")
        : (this.note.style.display = "none");
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.section.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          // aka only 1 option
          if (typeof this.options === "string") {
            return this.options === option;
          } else {
            return this.options[index] === option;
          }
        })
        .includes(false);
    });
  }

  /**
   * set the price - if a variant is selected
   */
  updatePrice() {
    if (!this.currentVariant) return;
    const isSale = this.currentVariant.compare_at_price && this.currentVariant.compare_at_price > this.currentVariant.price ? true : false;
    let unitElements = this.section.querySelectorAll(
      ".unit-price .price-item span:first-child"
    );
    let regularPrice = this.currentVariant.price;
    let priceWrapper = this.section.querySelectorAll('.product__info-wrapper .price, .product__info-mobile .price');

    if (isSale) {
      // reset the regular price to the compare_at_price, because the regular price will not be the lower sale-price
      regularPrice = this.currentVariant.compare_at_price;

      // add the sale price for each element (we have the price twice on the page: for mobile and desktop
      let salePriceElements = this.section.querySelectorAll(".product__info-wrapper .price-item--sale, .product__info-mobile .price-item--sale");
      salePriceElements.forEach( (salePriceElement) => {
        salePriceElement.innerHTML = this.formatPrice(this.currentVariant.price);
      });

      // same for the price wrapper. we have two (mobile and desktop) and both need the class for the sale
      priceWrapper.forEach( (pw) => {
        pw.classList.add('price--on-sale');
      });

    } else {
      priceWrapper.forEach( (pw) => {
        pw.classList.remove('price--on-sale');
      });

    }

    // update the regular price, this will need to happen regardless if there is a sale or not (again for both: mobile and desktop)
    let regularPriceElements = this.section
        .querySelectorAll(".product__info-wrapper .price-item--regular, .product__info-mobile .price-item--regular"); // TODO: OJO only in the infor-wrapper, not in mobile
    regularPriceElements.forEach( (regularPriceElement) => {
      // update the price
      regularPriceElement.innerHTML = this.formatPrice(regularPrice);

      // update the variant-id
      regularPriceElement.setAttribute("data-price-id", this.currentVariant.id);
    });

    if (unitElements) {
      const unitPrice = this.formatPrice(this.currentVariant.unit_price);
      unitElements.forEach((unit) => {
        unit.innerText = unitPrice;
      });
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = this.section.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = this.section.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);

    /* NEW Photogrid for Accessoires/Swatches */
    let btnTextMore = document.getElementById("showImagesBtnTxtMore");
    let btnTextLess = document.getElementById("showImagesBtnTxtLess");
    if (
      parent.children.length >= 4 &&
      window.matchMedia("(min-width: 759px)").matches
    ) {
      for (let i = 0; i < parent.children.length; i++) {
        if (i >= 4) {
          parent.children[i].classList.add("hidden");
          btnTextLess.classList.add("hidden");
          btnTextMore.classList.remove("hidden");
        } else {
          parent.children[i].classList.remove("hidden");
          btnTextLess.classList.remove("hidden");
          btnTextMore.classList.add("hidden");
        }

        parent.firstChild.style.gridColumn = "1 / span 3";
        if (parent.children[i] != parent.firstChild) {
          parent.children[i].style.gridColumn = "span 1";
        }
      }
      if (
        btnTextLess.classList.contains("hidden") == true &&
        btnTextMore.classList.contains("hidden") == false
      ) {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }
    } else {
      let buttons = document.getElementById("showImagesBtn");
      buttons.style.display = "none";
    }

    this.stickyHeader =
      this.stickyHeader || this.section.querySelector("sticky-header");
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
    }
    // todo if on first position, don't scroll
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
    this.id = window.location.search.split("?variant=")[1];
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = this.section.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    if (this.isNotify) {
      this.toggleAddButton(
        !this.currentVariant.available,
        window.variantStrings.notify,
        true,
        true
      );
    } else if (this.isUnavailableSwatchCombination) {
      this.toggleAddButton(
        !this.currentVariant.available,
        window.variantStrings.choose_option
      );
    } else {
      this.toggleAddButton(
        !this.currentVariant.available,
        window.variantStrings.soldOut
      );
    }
  }

  /**
   * Set the state of the CTA
   * @param {Boolean} disable true, if the CTA should be disabled
   * @param {String} text  text the CTA shoukd display
   * @param {Boolean} modifyClass currently not doing anything... but it is in Dawn
   * @param {Boolean} isNotify  true, if the product has a notify tag
   * @returns
   */
  toggleAddButton(disable = true, text, modifyClass = true, isNotify = false) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    if (!this.addButton) return;

    if (disable) {
      this.addButton.setAttribute("disabled", true);
      this.addButton.setAttribute("aria-disabled", true);
      if (isNotify) {
        if (this.note) this.note.style.display = "flex";
        if (this.noteShipping) this.noteShipping.style.display = "none";
        this.addButton.classList.add("hidden");
        this.notifyButton.classList.remove("hidden");
        if (this.isGlobalStrike) {
          this.notifyButton.classList.add("hidden");
          this.gsdButton.classList.remove("hidden");
        }
      } else {
        this.notifyButton.classList.add("hidden");
        this.addButton.classList.remove("hidden");
        if (this.note) {
          this.note.style.display = "flex";
          if (this.noteShipping) this.noteShipping.style.display = "none";
          if (this.isUnavailableSwatchCombination) {
            this.note.style.display = "none";
            if (this.noteShipping) this.noteShipping.style.display = "flex";
          }
        }
      }
      this.addButtonText.textContent = text;
    } else {
      this.addButton.removeAttribute("disabled");
      this.addButton.removeAttribute("aria-disabled");
      let btnPrice = this.currentVariant ? this.formatPrice(this.currentVariant.price) : this.price;

      if(this.variantIsPreOrder()) {
        this.addButtonText.textContent =
          window.variantStrings.preorder + ` - ${btnPrice}`;
          if (this.note) this.note.style.display = "none";
          if (this.noteShipping) this.noteShipping.style.display = "none";
          this.addButton.setAttribute("disabled", false);
          this.addButton.setAttribute("aria-disabled", false);
      } else {
        this.addButtonText.textContent =
          window.variantStrings.addToCart + ` - ${btnPrice}`;
      }
      if (this.note) {
        this.note.style.display = "none";
        if (!this.variantIsPreOrder() && this.isNotify) {
          if (this.noteShipping) this.noteShipping.style.display = "flex";
        }
      }
      if (this.variantIsPreOrder()) {
        this.notePreorder.classList.remove('hidden');
      }
    }

    if (!modifyClass) return;
  }

  formatPrice(currentPrice) {
    let priceLocale = Shopify.locale;

    /*
    * We need to base the money format on the chosen currency, not the locale.
    * We want the right formatting for e.g. pound, even when navigating the page in German
    * This is why we need to determine the locale we need for the money formate manually for now.
    * Until someone has a better idea on how to do this, because Shopify manages it fine in Liquid
    */
    switch(Shopify.currency.active) {
      case 'GBP': priceLocale = 'en-GB';
        break;
      case 'CHF': priceLocale = 'de-CH';
        break;
      case 'USD': priceLocale = 'en-US';
        break;
      default: priceLocale = 'de';
    }

    if(Shopify.currency.active !== 'USD' && Shopify.currency.active !== 'GBP'){
      return Intl.NumberFormat(priceLocale, {
        style: 'currency',
        currency: Shopify.currency.active
      }).format(currentPrice / 100);
    } else {
      return Intl.NumberFormat(priceLocale, {
        style: 'currency',
        currency: Shopify.currency.active
      }).format(currentPrice / 100) + ` ${Shopify.currency.active}`;
    }

  }

  setUnavailable() {
    if (!this.addButton) return;
    this.addButtonText.textContent = window.variantStrings.unavailable;
    if (this.price) this.price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        this.section.querySelector('[type="application/json"]').textContent
      );
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

/**
 * Variant-picker for PDP
 * Used on PDP when type="button" is selected for the variant-picker
 * Is used for shoe sizes on shoe PDPs
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.section.querySelectorAll("fieldset"));
    // console.log(fieldsets);
    // console.log(this.section);
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

/**
 * Variant-picker for PDP
 * Used on PDP when type="swatches" is selected for the variant-picker
 * Used for colors on accessory pages
 */
class VariantRadiosAccessoires extends VariantSelects {
  constructor() {
    super();
    this.isComing = document.querySelector(".is-coming-soon");
    this.isNotify = document.querySelector(".product.is-notify");
    this.isGlobalStrike = document.querySelector(".is-global-strike");
    this.noteShipping = document.querySelector(".product-form__shipping");
    this.note = document.querySelector(".product-form__note");
    this.getVariantData();

    if (!window.location.search.split("?variant=")[1]) {
      this.resetStateAcc();
    } else {
      this.checkState();
    }

    // if it's coming soon or global strike, do nothing on change of variant
    if (!this.isComing && !this.isGlobalStrike) {
      this.addEventListener("change", this.onVariantChange);
    } else {
      if (this.note) this.note.style.display = "flex";
      if (this.noteShipping) this.noteShipping.style.display = "none";
    }
  }

  resetStateAcc() {
    // remove the checked checkboxes as a reset if no variant is chosen
    const checkedInput = this.querySelectorAll("input:checked");
    this.querySelectorAll("input").forEach((input) =>
      input.removeAttribute("disabled")
    );
    this.querySelectorAll("label").forEach((label) =>
      label.classList.remove("is-soldout")
    );
    const wrapper = document.querySelector(".product-information_wrapper");
    for (let i = 0; i < checkedInput.length; i++) {
      checkedInput[i].removeAttribute("checked");
    }

    // if, it is not coming-soon: check the first option for the length to make variant-id available, if there are multiple options
    let lengthSwatch =
      this.querySelector('input[name="Länge"]') ||
      this.querySelector('input[name="Length"]');
    if (!this.isComing && lengthSwatch) {
      lengthSwatch.setAttribute("checked", "checked");
    }

    // if, it is not coming-soon: check the first option for the size to make variant-id available, if there are multiple options
    let sizeSwatch =
      this.querySelector('input[name="Größe"]') ||
      this.querySelector('input[name="size"]');
    if (!this.isComing && sizeSwatch) {
      sizeSwatch.setAttribute("checked", "checked");
    }

    // reset price in case there is a price range
    this.resetPrice();
    // reset featured media
    this.resetMedia();
    // unless it has endclips, by default endclips are selected
    // otherwise it messes up variant logic with only 2 proper options
    const endclipSelector = document.querySelector("#product-stopper");
    if (endclipSelector) {
      endclipSelector
        .querySelectorAll("input")[0]
        .setAttribute("checked", "checked");
    }
    // product is soldout but it's not global strike day
    if (this.isSoldout && !this.isGlobalStrike) {
      if (this.note) this.note.style.display = "flex";
      if (this.noteShipping) this.noteShipping.style.display = "none";
      if (this.isNotify) {
        this.addButton.classList.add("hidden");
        this.notifyButton.classList.remove("hidden");
        if (this.note) this.note.style.display = "flex";
        if (this.noteShipping) this.noteShipping.style.display = "none";
      }
    } else {
      // if it is global strike, show text for it
      if (this.isGlobalStrike) {
        this.isGlobalStrikeDay(wrapper);
        // otherwise show default 'choose size' button
      } else if (this.isComing) {
        this.hasComingSoonTag();
      } else {
        this.toggleAddButton(true, window.variantStrings.choose_option, false);
        if (this.note) this.note.style.display = "none";
        if (this.noteShipping) this.noteShipping.style.display = "flex";
      }
    }

    // set every soldout item to sold out for second option (color)
    const soldOuts = this.variantData.filter((variant) => !variant.available);
    soldOuts.forEach((item) => {
      if (item.option2 != null) {
        this.setSoldoutState(item.option2);
      }
      // check if soldout variant is the first option - if unselected state
      if (this.variantData[0].option2 === item.option2) {
        this.setSoldoutState(item.option1);
      }
    });
    this.setAvailable();
  }

  resetPrice() {
    const priceElement = this.isSale ? document.querySelector(".product__info-wrapper .price-item--sale") : document.querySelector(".product__info-wrapper .price-item--regular");
    const priceElementMobile = this.isSale ? document.querySelector(".product__info-mobile .price-item--sale") : document.querySelector(".product__info-mobile .price-item--regular");

    const product = JSON.parse(this.querySelector("#product-json").textContent);

    if (product.price_max !== product.price_min) {
      const priceRange = window.variantStrings.price_range
        .replace("[min]", this.formatPrice(product.price_min))
        .replace("[max]", this.formatPrice(product.price_max));

      priceElement.innerHTML = priceRange;
      priceElementMobile.innerHTML = priceRange;
    }
  }

  // if reset state, removes featured image and adds it on second position
  resetMedia() {
    const featuredMedia = document.querySelector(".featured_media");
    let medias = document.querySelectorAll(".product__media-list > li");
    if (featuredMedia) {
      var nodes = [].slice.call(medias, 1);
      nodes[0].after(featuredMedia);
    }
  }

  // Called when an element is checked and updates options accordingly
  checkState() {
    this.updateOptions();
    this.updateMasterId();
    const hasSeveralOptions = this.variantData.filter(
      (variant) => variant.option2
    );
    let possibleProducts = [];
    if (hasSeveralOptions.length > 0) {
      possibleProducts = this.variantData.filter(
        (variant) => variant.option2 == this.currentVariant.option2
      );
    }
    // removes disabled state
    this.querySelectorAll("input").forEach((input) =>
      input.removeAttribute("disabled")
    );
    this.querySelectorAll("label").forEach((label) =>
      label.classList.remove("is-soldout"),
    );

    if (possibleProducts.length > 0 && hasSeveralOptions.length > 0) {
      this.checkPossibleOptions(possibleProducts);
      // checks which element is sold out
      const possibleSoldouts = possibleProducts.filter(
        (variant) => !variant.available
      );
      // if all are sold out, make disabled.
      if (possibleSoldouts.length === possibleProducts.length) {
        const currentInput = document.querySelector(
          'input[value="' + possibleProducts[0].option2 + '"'
        );
        let labelId = currentInput.getAttribute("aria-labelledby");
        currentInput.disabled = true;
        document
          .querySelector(`label[id="${labelId}"]`)
          .classList.add("is-soldout");
      }
      // set the unavailable colors to disabled
      this.variantData
        .filter((variant) => !variant.available)
        .forEach((variant) => {
          this.setSoldoutState(variant.option2);
        });
      // set length from selected to soldout
      possibleSoldouts.forEach((item) => {
        this.setSoldoutState(item.option1);
        if (item.option2 != null) {
          this.setSoldoutState(item.option2);
        }
      });

      // make colors available again
      this.setAvailable();
    } else {
      // set every soldout item to sold out for second option (color)
    const soldOuts = this.variantData.filter((variant) => !variant.available);
    soldOuts.forEach((item) => {
      if (item.option2 != null) {
        this.setSoldoutState(item.option2);
      }
      // check if soldout variant is the first option - if unselected state
      if (this.variantData[0].option2 === item.option2) {
        this.setSoldoutState(item.option1);
      }
    });

      // as only one option is available check for it
      this.setAvailable(1);
    }
  }

  // gets all available items and sets them enabled
  setAvailable(setOption) {
    setOption = setOption || 2;
    const availableVariants = this.variantData.filter(
      (variant) => variant.available
    );

    availableVariants.forEach((variant) => {
      if (variant.option2 !== null) {
        let option = setOption === 1 ? variant.option1 : variant.option2;
        const currentInput = document.querySelector(
          'input[value="' + option + '"'
        );
        let labelId = currentInput.getAttribute("aria-labelledby");
        currentInput.disabled = false;
        document
          .querySelector(`label[id="${labelId}"]`)
          .classList.remove("is-soldout");
      }
    });
  }

  setSoldoutState(option) {
    const input = document.querySelector('input[value="' + option + '"');
    let labelId = input.getAttribute("aria-labelledby");
    if (!this.isNotify) {
      input.disabled = true;
    }
    document
      .querySelector(`label[id="${labelId}"]`)
      .classList.add("is-soldout");
  }

  updateOptions() {
    const checkedInput =
      this.querySelectorAll("#product-stopper").length > 0
        ? Array.from(
            this.querySelectorAll('input:not([name="Endclip"]):checked')
          )
        : Array.from(this.querySelectorAll("input:checked"));
    let possibleVariants = "";
    this.optionType = [];
    this.optionPosition = [];

    if (checkedInput.length > 1) {
      const fieldsets = Array.from(
        this.querySelectorAll("fieldset:not(.selector-stopper)")
      );
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      });
      // to figure out which label to put the info
      checkedInput.forEach((input) => {
        this.optionType.push(input.parentElement.getAttribute("data-option"));
        this.optionPosition.push(
          input.parentElement.getAttribute("data-position")
        );
      });
    } else {
      this.options = checkedInput[0].value;
      this.optionType.push(
        checkedInput[0].parentElement.getAttribute("data-option")
      );
      this.optionPosition.push(
        checkedInput[0].parentElement.getAttribute("data-position")
      );
    }

    // checks if options is a string, if not filter
    if (typeof this.options !== "string") {
      // going through the options as they are choosen and update label accordingly
      this.optionType.forEach((type, index) => {
        const label = document.getElementById("label-" + type);
        label.textContent = ": " + this.options[index];
      });
      // always has option 1 & 2, so we choose as available via the color
      possibleVariants = this.variantData.filter(
        (variant) => variant.option2 === this.options[1]
      );
    } else {
      const label = document.getElementById("label-" + this.optionType);
      label.textContent = ": " + this.options;
      // if color is chosen first optionPosition is 2, otherwise it's 1
      possibleVariants =
        this.optionPosition[0] === "2"
          ? this.variantData.filter(
              (variant) => variant.option2 === this.options
            )
          : this.variantData.filter(
              (variant) => variant.option1 === this.options
            );
    }

    this.checkPossibleOptions(possibleVariants);
  }

  combinationAvailable() {
    // when currently clicked color is not available in the option combination, reset button
    if (this.currentVariant.id) {
      const currentVariant = this.variantData.filter(
        (variant) => variant.id === this.currentVariant.id
      );
      if (!currentVariant[0].available) {
        this.setUnavailable();
        this.addButton.disabled = true;
        this.addButton.setAttribute("aria-disabled", true);
        this.isUnavailableSwatchCombination = true;
      }
    }
  }

  checkPossibleOptions(possibleVariants) {
    let lengthInput = this.querySelectorAll(
      '.swatch-element[data-position="1"]'
    );
    // change label Length depending on length choosen
    const labelLength =
      document.getElementById("label-länge") ||
      document.getElementById("label-größe");
    if (labelLength && typeof this.options !== "string") {
      labelLength.textContent = ": " + this.options[0];
    }

    // hide all options if more shown than should be as that means there are less option available than shown
    if (
      possibleVariants.length < lengthInput.length &&
      possibleVariants.length > 1
    ) {
      lengthInput.forEach((input) => (input.style.display = "none"));
    }

    for (let index = 0; index < possibleVariants.length; index++) {
      const variant = possibleVariants[index];
      const input = document.querySelector(`[value="${variant.option1}"]`);
      const label = input.closest("div").querySelector("label");
      const wrapper = input.closest("div");

      // show options that actually exist
      if (label.textContent.includes(variant.option1)) {
        wrapper.style.display = "flex";
      }

      if (!variant.available) {
        input.classList.add("is-soldout");
        label.classList.add("is-soldout");
        if (!this.isNotify) input.setAttribute("disabled", true);
      } else {
        input.classList.remove("is-soldout");
        label.classList.remove("is-soldout");
        if (!this.isNotify) input.removeAttribute("disabled", true);
      }
    }

    if (this.currentVariant) {
      this.combinationAvailable();
    }
  }

  setUnavailable() {
    if (!this.addButton) return;
    // changes button to choose option whenever only one option is checked
    this.addButtonText.textContent = window.variantStrings.choose_option;
    if (this.noteShipping) this.noteShipping.style.display = "flex";
    if (this.note) this.note.style.display = "none";
  }
}

customElements.define("variant-radios-accessoires", VariantRadiosAccessoires);